var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHumanAndCivilRights = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Donation-Charity-Care-Person-Male-2--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Donation Charity Care Person Male 2 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.85 18.65a0.25 0.25 0 0 1 -0.12 -0.28l0.49 -2.15c0.34 -1.44 -1 -2 -1.69 -0.94A22.46 22.46 0 0 0 16 19.1a0.92 0.92 0 0 0 0 0.29v4.11a0.25 0.25 0 0 0 0.25 0.25h3.5a0.25 0.25 0 0 0 0.25 -0.25v-1.07a0.49 0.49 0 0 1 0.15 -0.36l3.56 -3.53a1 1 0 0 0 0.29 -0.71v-7.14a0.51 0.51 0 0 0 -0.21 -0.41 0.5 0.5 0 0 0 -0.46 -0.06c-0.72 0.25 -1.8 1.39 -1.83 5.83a0.49 0.49 0 0 1 -0.15 0.35l-2.2 2.2a0.26 0.26 0 0 1 -0.3 0.05Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.86 22.07a0.52 0.52 0 0 1 0.14 0.35v1.08a0.25 0.25 0 0 0 0.25 0.25h3.5A0.25 0.25 0 0 0 8 23.5v-4.11a0.92 0.92 0 0 0 0 -0.29 22.46 22.46 0 0 0 -1.49 -3.82c-0.72 -1.11 -2 -0.5 -1.69 0.94l0.49 2.15a0.25 0.25 0 0 1 -0.12 0.28 0.26 0.26 0 0 1 -0.3 0l-2.2 -2.2a0.49 0.49 0 0 1 -0.15 -0.35c0 -4.44 -1.1 -5.58 -1.83 -5.83a0.5 0.5 0 0 0 -0.46 0.06 0.51 0.51 0 0 0 -0.21 0.41v7.1a1 1 0 0 0 0.33 0.75c0.99 0.88 2.96 2.92 3.49 3.48Z",
    fill: "currentColor",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.85 7.53a0.91 0.91 0 0 1 0 -0.69A5 5 0 0 0 15 3.3a2.88 2.88 0 0 0 -3 -3 2.88 2.88 0 0 0 -3 3 5 5 0 0 0 1.13 3.51 1 1 0 0 1 0 0.71C8.09 8.27 7 8.81 6.5 9.68a5.26 5.26 0 0 0 -0.5 1.48 0.48 0.48 0 0 0 0.11 0.41 0.49 0.49 0 0 0 0.38 0.18h11a0.49 0.49 0 0 0 0.38 -0.18 0.48 0.48 0 0 0 0.11 -0.41 5.26 5.26 0 0 0 -0.49 -1.48c-0.44 -0.87 -1.58 -1.41 -3.64 -2.15Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHumanAndCivilRights);
export default ForwardRef;